import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserInvite, OrganizationUser, OrganizationUsersResult } from './account-team-user.model';

const BASE_URL = `${environment.apiOrg.url}/organization-users`;

@Injectable()
export class AccountTeamUserService {
  constructor(private http: HttpClient) {}

  loadAccountTeamUsers() {
    return this.http.get<OrganizationUsersResult>(BASE_URL);
  }

  inviteUser(user: UserInvite) {
    return this.http.post<OrganizationUser>(BASE_URL, user);
  }

  resendInvitation(userId: string) {
    const url = `${environment.apiOrg.url}/organization-user-profile/${userId}/resend-invitation`;
    return this.http.post<void>(url, {});
  }

  // TODO - retire legacy code STUD-2700
  removePendingUser(userId: string) {
    const url = `${BASE_URL}/pending/legacy/${userId}`;
    return this.http.delete(url);
  }

  // TODO - retire legacy code STUD-2700
  removeUser(userId: string) {
    return this.http.delete(`${BASE_URL}/legacy/${userId}`);
  }

  removeUserFromOrg(userId: string) {
    const url = `${BASE_URL}/${userId}`;
    return this.http.delete(url);
  }

  updateOrganizationRoles(userId, organizationRoles) {
    const url = `${environment.apiOrg.url}/organization-user-profile/${userId}/roles`;
    return this.http.post<OrganizationUser>(url, organizationRoles);
  }
}
